export const BASE_URL = "https://wedspot.gabatch13.my.id";